import { ColumnsWidths } from '../../utils';

/* eslint-disable @typescript-eslint/naming-convention */
export const getColumnsWidths = (): ColumnsWidths[] => ([
  { 'Round Name': 126 } ,{ MOIC: 74 }, { IRR: 74 }, { 'Current Holding %': 74 },
  { 'Valuated/Sale PPS': 74 }, { 'Holding after Round %': 74 },
  { 'Current Holding %': 74 }, { 'Lead Investor': 188 },
]);
/* eslint-enable @typescript-eslint/naming-convention */
